/**
 * @fileoverview added by tsickle
 * Generated from: formio.config.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import { Injectable } from '@angular/core';
import * as ɵngcc0 from '@angular/core';
var FormioAppConfig = /** @class */ (function () {
    function FormioAppConfig() {
        this.appUrl = '';
        this.apiUrl = '';
    }
FormioAppConfig.ɵfac = function FormioAppConfig_Factory(t) { return new (t || FormioAppConfig)(); };
FormioAppConfig.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: FormioAppConfig, factory: function (t) { return FormioAppConfig.ɵfac(t); } });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(FormioAppConfig, [{
        type: Injectable
    }], function () { return []; }, null); })();
    return FormioAppConfig;
}());
export { FormioAppConfig };
if (false) {
    /** @type {?} */
    FormioAppConfig.prototype.appUrl;
    /** @type {?} */
    FormioAppConfig.prototype.apiUrl;
    /** @type {?} */
    FormioAppConfig.prototype.icons;
    /** @type {?} */
    FormioAppConfig.prototype.formOnly;
}

//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZm9ybWlvLmNvbmZpZy5qcyIsInNvdXJjZXMiOlsiZm9ybWlvLmNvbmZpZy5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7O0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTs7Ozs7Z0RBR007QUFDTjtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQSIsInNvdXJjZXNDb250ZW50IjpbIi8qKlxuICogQGZpbGVvdmVydmlldyBhZGRlZCBieSB0c2lja2xlXG4gKiBHZW5lcmF0ZWQgZnJvbTogZm9ybWlvLmNvbmZpZy50c1xuICogQHN1cHByZXNzIHtjaGVja1R5cGVzLGNvbnN0YW50UHJvcGVydHksZXh0cmFSZXF1aXJlLG1pc3NpbmdPdmVycmlkZSxtaXNzaW5nUmV0dXJuLHVudXNlZFByaXZhdGVNZW1iZXJzLHVzZWxlc3NDb2RlfSBjaGVja2VkIGJ5IHRzY1xuICovXG5pbXBvcnQgeyBJbmplY3RhYmxlIH0gZnJvbSAnQGFuZ3VsYXIvY29yZSc7XG52YXIgRm9ybWlvQXBwQ29uZmlnID0gLyoqIEBjbGFzcyAqLyAoZnVuY3Rpb24gKCkge1xuICAgIGZ1bmN0aW9uIEZvcm1pb0FwcENvbmZpZygpIHtcbiAgICAgICAgdGhpcy5hcHBVcmwgPSAnJztcbiAgICAgICAgdGhpcy5hcGlVcmwgPSAnJztcbiAgICB9XG4gICAgRm9ybWlvQXBwQ29uZmlnLmRlY29yYXRvcnMgPSBbXG4gICAgICAgIHsgdHlwZTogSW5qZWN0YWJsZSB9LFxuICAgIF07XG4gICAgcmV0dXJuIEZvcm1pb0FwcENvbmZpZztcbn0oKSk7XG5leHBvcnQgeyBGb3JtaW9BcHBDb25maWcgfTtcbmlmIChmYWxzZSkge1xuICAgIC8qKiBAdHlwZSB7P30gKi9cbiAgICBGb3JtaW9BcHBDb25maWcucHJvdG90eXBlLmFwcFVybDtcbiAgICAvKiogQHR5cGUgez99ICovXG4gICAgRm9ybWlvQXBwQ29uZmlnLnByb3RvdHlwZS5hcGlVcmw7XG4gICAgLyoqIEB0eXBlIHs/fSAqL1xuICAgIEZvcm1pb0FwcENvbmZpZy5wcm90b3R5cGUuaWNvbnM7XG4gICAgLyoqIEB0eXBlIHs/fSAqL1xuICAgIEZvcm1pb0FwcENvbmZpZy5wcm90b3R5cGUuZm9ybU9ubHk7XG59XG4iXX0=